<template>
  <div>
    <b-container v-if="post" class="main-container">
      <b-row>
        <b-col class="post-header">
          <p class="post-title">{{ post.title }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p class="post-desc left-align">Written By: {{ post.author }}</p>
        </b-col>
        <b-col>
          <p class="post-desc right-align">{{ post.date | formatDate }}</p>
        </b-col>
      </b-row>
      <div class="blog-container">
        <div class="blog-gradient"></div>

        <b-row>
          <b-col v-if="shortContent">
            <vue-markdown :source="shortContent" />
            <router-link class="read-more" :to="'/post/' + post.id"
              >read more</router-link
            >
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-render';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    'vue-markdown': VueMarkdown
  },
  props: {
    postId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      post: null
    };
  },
  computed: {
    ...mapGetters('blog', ['blogPostById']),

    shortContent() {
      if (!this.post || !this.post.content) {
        return '';
      }
      return this.post.content.slice(0, 500);
    }
  },
  methods: {
    ...mapActions('blog', ['fetchBlogPostContent']),

    goToFullBlogPost() {
      this.$router.push({
        name: 'full',
        params: {
          id: this.post.id,
          data: { post: this.post, content: this.content }
        }
      });
    }
  },
  async created() {
    if (
      this.blogPostById(this.postId) &&
      this.blogPostById(this.postId).content === null
    ) {
      await this.fetchBlogPostContent(this.postId);
    }
    this.post = this.blogPostById(this.postId);
  },
  mounted() {}
};
</script>

<style scoped>
.read-more {
  color: rgb(12, 192, 150);
  font-size: 24px;
}
.main-container {
  margin-bottom: 50px;
}

.blog-container {
  border: 1px solid rgb(12, 192, 150);
  /* border-top: none; */
  padding: 1rem;
  position: relative;
}

.post-header {
  text-align: left;
}

.post-title {
  font-weight: bold;
  font-size: 32px;
  color: rgb(12, 192, 150);
  line-height: 1.5rem;
  margin-bottom: .5rem;
}

.post-desc {
  font-weight: bold;
  color: gray;
  margin-bottom: .5rem;
}

.left-align {
  text-align: left;
}

.right-align {
  text-align: right;
}

.no-margin {
  margin: 0;
}

.blog-gradient {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 25%;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 0, 0, 0),
    rgba(159, 159, 159, 0.574)
  );
}
</style>
